






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'ChipButton',
})
export default class ChipButton extends Vue {
	@Prop({ type: Boolean, default: false }) active: boolean;
	@Prop({ type: Boolean, default: false }) noBorders: boolean;
}
